export default class OpenEntriesRowData {
    constructor(value) {
        this.CompanyName = value.compName[0];
        this.DocumentDate = value.postingDate[0];
        this.DocumentType = value.docType[0];
        this.DocumentNo = value.docNo[0];
        this.ExternalDocNo = value.extDocNo[0];
        this.Reference = value.reference[0];
        this.ChargeType = value.description[0];
        this.Currency = value.currency[0];
        this.OriginalAmount = value.originalAmount[0];
        this.OriginalVATAmount = value.vatamount[0];
        this.RemaningAmount = value.remainingAmount[0];
        this._interface = value.interface[0];
    }
}
